import ClickOutside from 'vue-click-outside'
import { mapState, mapMutations } from "vuex";

export default {
	template: "#checkout-comment",
	props: {
		step: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
            
		}
	},
	components: {
	},
	computed: {
		...mapState({
			props: state => state.comment.props,
			errorMessages: state => state.checkout.errorMessages
		}),
        commentProp() {
            return this.props.find(prop => prop.code === "COMMENT");
        }
	},
	methods: {
		...mapMutations({
			setPropValue: "comment/setPropValue",
		}),
		clickOutside(e) {
		},
		handleFormInput(e, code) {
			this.setPropValue({value: e.target.value, code});
		},
		handleFormBlur(e) {
			e.target.dispatchEvent(new Event("input"));
		},
	},
	watch: {
	},
	directives: {
		ClickOutside
	},
	mounted() {
	},
	created() {
	}
}
